import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withRouterConfig,
  withInMemoryScrolling,
  withViewTransitions,
  RouteReuseStrategy,
  TitleStrategy,
  // withDebugTracing,
  withComponentInputBinding,
  Router,
} from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { AuthModule } from './auth/auth.module';
import { GlobalErrorHandler } from '@shared/utils/global-error-handler';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '@shared/shared.module';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { SafeReuseStrategy } from '@shared/utils/safe-reuse-strategy';
import { authInterceptor } from '@shared/service/interceptors';
import { CustomTitleStrategy } from '@shared/utils/custom-title-strategy';
import * as Sentry from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: RouteReuseStrategy, useClass: SafeReuseStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    // Sentry TraceService for performance monitoring and router instrumentation
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAnimations(),
    importProvidersFrom(AuthModule),
    provideRouter(
      routes,
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      // withDebugTracing(), // TODO: Debug mode
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
